// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "integration_connection_health".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { connectionHealthRemedyValues, connectionHealthStateValues, connectionProviderValues } from '@borradh-workspace/labels';
/** Response atom for the "integration_connection_health" table (1:1 with a DB row, on the wire). */
export const integrationConnectionHealthAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    provider: z.enum(connectionProviderValues),
    connectionId: z.string(),
    label: z.string().nullable(),
    state: z.enum(connectionHealthStateValues),
    reasonCode: z.string(),
    remedy: z.enum(connectionHealthRemedyValues),
    detail: z.string().nullable(),
    actionUrl: z.string().nullable(),
    actionLabel: z.string().nullable(),
    videoGuideSlug: z.string().nullable(),
    metadata: z.unknown().nullable(),
    checkedAt: z.string().datetime(),
    stateSince: z.string().datetime(),
    lastNotifiedAt: z.string().datetime().nullable(),
    notifyCount: z.number(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=integrationConnectionHealth.js.map